export default __webpack_public_path__ + "ad54ff6b85c7d833b617d2599a8de14c.svg";